import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import useCylindoDimensionShots from 'data-hooks/useCylindoDimensionShots';
import PDPDimensionsContentUI from './PDPDimensionsContentUI';
const PDPDimensionsContent = t0 => {
  const $ = _c(12);
  const {
    isSidebarContent,
    onImageClick,
    pageLoading: t1,
    upholsteryKey
  } = t0;
  const pageLoading = t1 === undefined ? false : t1;
  const {
    loading,
    error,
    data: t2
  } = useProductAttributes();
  const {
    dimensions,
    custom_properties,
    boxDimensions,
    boxDimensionsPending
  } = t2;
  let t3;
  if ($[0] !== upholsteryKey) {
    t3 = {
      upholsteryKey
    };
    $[0] = upholsteryKey;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const dimensionShotsData = useCylindoDimensionShots(t3);
  if (error) {
    return null;
  }
  const t4 = loading || pageLoading;
  const t5 = custom_properties?.dimensional_image_desktop;
  const t6 = custom_properties?.dimensional_image_mobile;
  let t7;
  if ($[2] !== boxDimensions || $[3] !== boxDimensionsPending || $[4] !== dimensionShotsData || $[5] !== dimensions || $[6] !== isSidebarContent || $[7] !== onImageClick || $[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <PDPDimensionsContentUI loading={t4} dimensionsDesktopImage={t5} dimensionsMobileImage={t6} dimensions={dimensions} boxDimensions={boxDimensions} boxDimensionsPending={boxDimensionsPending} onImageClick={onImageClick} isSidebarContent={isSidebarContent} {...dimensionShotsData} />;
    $[2] = boxDimensions;
    $[3] = boxDimensionsPending;
    $[4] = dimensionShotsData;
    $[5] = dimensions;
    $[6] = isSidebarContent;
    $[7] = onImageClick;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  return t7;
};
PDPDimensionsContent.propTypes = {
  isSidebarContent: PropTypes.bool,
  onImageClick: PropTypes.func,
  pageLoading: PropTypes.bool,
  upholsteryKey: PropTypes.string
};
export default PDPDimensionsContent;